import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Header } from "@/components/iv/Header";
import { StepperGrid } from "@/components/iv/StepperGrid";
import { StepperNav } from "@/components/iv/StepperNav";
import { Hero } from "@/components/iv/Hero";
import { ComparisonMatrix } from "@/components/iv/ComparisonMatrix";
import { TierCards } from "@/components/iv/TierCards";
import { FaqSection } from "@/components/iv/FaqSection";
import { ComingNextPanel } from "@/components/iv/ComingNextPanel";
import { SiteFooter } from "@/components/iv/SiteFooter";
import { IntakeStage } from "@/components/iv/intake/IntakeStage";
import { ScorecardStage } from "@/components/iv/scorecard/ScorecardStage";
import { ConceptStage } from "@/components/iv/concept/ConceptStage";
import { STAGES } from "@/constants/content";

const clampStage = (v) => Math.min(STAGES.length, Math.max(1, parseInt(v, 10) || 1));

export default function Workspace() {
  const [params, setParams] = useSearchParams();
  const stage = clampStage(params.get("stage"));

  useEffect(() => {
    const raw = params.get("stage");
    if (raw !== null && raw !== String(stage)) {
      setParams((p) => { const q = new URLSearchParams(p); q.set("stage", String(stage)); return q; }, { replace: true });
    }
  }, [params, stage, setParams]);
  const goTo = useCallback((n) => {
    const next = clampStage(n);
    setParams((p) => { const q = new URLSearchParams(p); q.set("stage", String(next)); return q; });
    document.getElementById("journey")?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [setParams]);

  return (
    <div className="min-h-screen" data-testid="workspace-page">
      <Header />
      <main className="mx-auto max-w-7xl px-4 sm:px-6">
        <div id="journey" className="scroll-mt-40 pt-5" data-testid="journey-section">
          <StepperGrid current={stage} onSelect={goTo} />
          <StepperNav current={stage} total={STAGES.length} onChange={goTo} />
        </div>
        {stage === 1 && (
          <div data-testid="stage-1-landing">
            <Hero onStage={goTo} />
            <ComparisonMatrix />
            <TierCards onStage={goTo} />
            <FaqSection />
          </div>
        )}
        {stage === 2 && <IntakeStage />}
        {stage === 3 && <ScorecardStage onStage={goTo} />}
        {stage === 4 && <ConceptStage />}
        {stage > 4 && <ComingNextPanel key={stage} stage={stage} onStage={goTo} />}
      </main>
      <SiteFooter />
    </div>
  );
}
